import React from "react";
import { HandoverTypeEnum, UploadedFile } from "../types";
import ReadOnlyTextField from "../FormComponents/ReadOnlyTextField";
import ReadOnlyFieldWrapper from "../ReadOnlyFieldWrapper";
import FormFieldLayout from "../FormComponents/FormFieldLayout";
import ReadOnlyUploadedFile from "../FormComponents/ReadOnlyUploadedFile";
import { handoverTypeToMsg } from "./helper";

export const CTReadOnlyHeader = ({
  handoverType,
  attachment,
}: {
  handoverType: HandoverTypeEnum;
  attachment?: UploadedFile;
}) => {
  return (
    <FormFieldLayout multipleFields>
      <ReadOnlyFieldWrapper value={handoverType}>
        <ReadOnlyTextField
          label="Would you like to transfer or close the accounts?"
          value={handoverTypeToMsg[handoverType]}
        />
      </ReadOnlyFieldWrapper>
      {attachment && (
        <FormFieldLayout>
          <ReadOnlyUploadedFile attachment={attachment} />
        </FormFieldLayout>
      )}
    </FormFieldLayout>
  );
};
